import React, { Fragment } from 'react'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import PrediosComponent from './PrediosComponent';
import ViverosComponent from './ViverosComponent';
import { obtenerTodosPrediosClientes, obtenerTodosViverosClientes } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks';
import { useDispatch, useSelector } from 'react-redux'

function TabsPrediosViverosComponent(props) {
    let detalleCliente = props?.detalle

    const dispatch = useDispatch()

    const [prediosViveros, setPrediosViveros] = React.useState(detalleCliente?.prediocliente.length > 0 ? 'predios' : 'viveros');

    const handleChangePrediosViveros = (event, newValue) => {
        setPrediosViveros(newValue);
    };

    const [predios, setPredios] = React.useState([]);
    const [ismodificacion, setIsModificacion] = React.useState(false);
    
    const [viveros, setViveros] = React.useState([]);
    
    React.useEffect(async () => {
        if (prediosViveros == 'predios') {
            let respredios = await dispatch(obtenerTodosPrediosClientes(detalleCliente?.idcliente))
            setPredios(respredios?.payload)
        }
        if (prediosViveros == 'viveros') {
            let resviveros = await dispatch(obtenerTodosViverosClientes(detalleCliente?.idcliente))
            setViveros(resviveros?.payload)
        }
        setIsModificacion(false)
    }, [prediosViveros,ismodificacion])

    return (
        <Fragment>
            <Box sx={{ width: '100%', typography: 'body1', marginTop: '3%' }}>
                <TabContext value={prediosViveros}>
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        textAlign: 'center', backgroundColor: '#fcfcfc',
                        boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px'
                    }}>
                        <TabList onChange={handleChangePrediosViveros} aria-label="lab API tabs example" className='text-center'
                            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                            sx={{
                                "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold' },
                                "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
                                "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
                            }}>
                            { detalleCliente?.prediocliente.length > 0 &&
                                <Tab label="Predios" value="predios" />
                            }
                            { detalleCliente?.viverocliente.length > 0 &&
                                <Tab label="Vivieros" value="viveros" />
                            }
                        </TabList>
                    </Box>
                    <TabPanel value="predios">
                        <div className='row'>
                            {ordenarActivosASC(sortJSON(predios, 'isbaja', 'asc'), 'predios')?.map((predio, index) =>
                                <div key={index} className='col-md-4 col-12 mt-5 mb-5'>
                                    <PrediosComponent data={predio} setIsModificacion={setIsModificacion} index={index}/>
                                </div>
                            )}
                        </div>
                    </TabPanel>
                    <TabPanel value="viveros">
                        <div className='row'>
                            {ordenarActivosASC(sortJSON(viveros, 'isbaja', 'asc'), 'viveros')?.map((vivero, index) =>
                                <div key={index} className='col-md-4 col-12 mt-5 mb-5'>
                                    <ViverosComponent data={vivero} setIsModificacion={setIsModificacion} index={index}/>
                                </div>
                            )}
                        </div>
                    </TabPanel>
                </TabContext>
            </Box>
        </Fragment >
    )
}
function sortJSON(data, key, orden) {
    const dataCopy = [...data];

    return dataCopy.sort(function (a, b) {
        var x = a[key],
            y = b[key];

        if (orden === 'asc') {
            if (x === y) return 0;
            if (x === false) return -1;
            if (y === false) return 1;
            return 0;
        }

        if (orden === 'desc') {
            if (x === y) return 0;
            if (x === true) return -1;
            if (y === true) return 1;
            return 0;
        }
    });
}
function ordenarActivosASC(array, idName){
    let activos = []
    let inactivos = []

    array?.map(item => {
        if (item?.isbaja == false) activos.push(item)
        else if (item?.isbaja == true) inactivos.push(item)
    })

    if(activos.length > 1) {
        if (idName == 'predios') activos.sort(((a, b) => a.idpredio - b.idpredio));
        else if (idName == 'viveros') activos.sort(((a, b) => a.idvivero - b.idvivero));
    }

    return activos.concat(inactivos);
}
export default TabsPrediosViverosComponent